import permissionsData from "../assets/permissions.json";

export type PermissionKey = keyof typeof permissionsData.permissions;

export interface Permission {
  name: PermissionKey;
  route: string;
  url: string;
  roles: string[];
}

export const PUBLIC_ROUTE_KEYS = ["profile", "logout"];

export const PERMISSIONS: Record<PermissionKey, Permission> = Object.entries(
  permissionsData.permissions
).reduce((acc, [key, value]) => {
  acc[key as PermissionKey] = { name: key as PermissionKey, route: value.route, url: value.url, roles: value.roles };
  return acc;
}, {} as Record<PermissionKey, Permission>);

export const ROLES = Array.from(new Set(Object.values(permissionsData.permissions).flatMap(p => p.roles))) as string[];

const permissionByUrl: Record<string, Permission> = Object.entries(
  PERMISSIONS
).reduce((acc, [key, value]) => {
  acc[value.url] = value;
  return acc;
}, {} as Record<string, Permission>);

const permissionByRoute: Record<string, Permission> = Object.entries(
  PERMISSIONS
).reduce((acc, [key, value]) => {
  acc[value.route] = value;
  return acc;
}, {} as Record<string, Permission>);

export const getPermissionUrl = (key: PermissionKey): string => {
  return PERMISSIONS[key]?.url || "";
};

export const getPermissionRoute = (key: PermissionKey): string => {
  return PERMISSIONS[key]?.route || "";
};

export const getPermissionByUrl = (url: string): Permission | undefined => {
  return permissionByUrl[url];
};

export const getPermissionByRoute = (route: string): Permission | undefined => {
  return permissionByRoute[route];
};

export const getAllPermissions = () => {
  return Object.values(permissionByRoute);
};

export const isUrlPermitted = (
  url: string,
  userPermissions: PermissionKey[]
): boolean => {
  const permission = getPermissionByUrl(url);
  return permission
    ? userPermissions.includes(permission.name as PermissionKey)
    : false;
};

export const isRoutePermitted = (
  route: string,
  userPermissions: PermissionKey[]
): boolean => {
  const permission = getPermissionByRoute(route);
  return permission
    ? userPermissions.includes(permission.name as PermissionKey)
    : false;
};
